import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useAppContext } from 'contexts/AppContext';
import { useAuthContext } from 'contexts/AuthContext';
import classNames from 'classnames';
import AuthenticatedNavbarTop from 'components/navbar/authenticated/NavbarTop';
import UnauthenticatedNavbarTop from 'components/navbar/unauthenticated/NavbarTop';
import Footer from 'components/footer/Footer';

const MainLayout = () => {
  const { hash, pathname } = useLocation();
  let { isAuthenticated } = useAuthContext();
  const { isFluid } = useAppContext();

  useEffect(() => {
    setTimeout(() => {
      if (hash) {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
      }
    }, 0);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className={isFluid ? 'container-fluid' : 'container'}>
      <div className={classNames('content')}>
        {isAuthenticated ? (
          <AuthenticatedNavbarTop />
        ) : (
          <UnauthenticatedNavbarTop />
        )}
        <Outlet />
        <Footer />
      </div>
    </div>
  );
};

export default MainLayout;
